import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { AirfoilStyles } from "../../AirfoilStyles/index.js";
import { IconWrapper } from "../../IconWrapper/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import { useIndexTableDisabled } from "../IndexTableContext.js";
import '../../../assets/index22.css';const iconCell = "_iconCell_150m6_1";
const grey = "_grey_150m6_10";
const disabled = "_disabled_150m6_13";
const s = {
  iconCell,
  grey,
  disabled
};
const IndexTableCellIcon = forwardRef(
  ({ iconColor = "grey", className, children, ...rest }, ref) => {
    const disabled2 = useIndexTableDisabled(rest);
    const semantic = iconColor === "red" ? "critical" : "success";
    return /* @__PURE__ */ jsx(
      "div",
      {
        ...rest,
        ref,
        className: clsx(
          s.iconCell,
          {
            [s.disabled]: disabled2,
            [s.grey]: !disabled2 && iconColor === "grey"
          },
          AirfoilStyles.getSemanticClassName(semantic),
          className
        ),
        children: /* @__PURE__ */ jsx(IconWrapper, { size: "sm", children })
      }
    );
  }
);
export {
  IndexTableCellIcon
};
